import { Box } from '@mui/material';
import React from 'react';
import { Palette } from 'Palette';
import { StyledButton } from '../styles/StyledButtons';
import StyledSection from '../styles/StyledSection';
import { StyledCard, StyledCardContent, StyledHeading, StyledTypography } from '../styles/styles';

interface PlaceholderContactCompletedViewProps {
  tone?: keyof typeof Palette;
  onViewContact: () => void;
  onReturnToActions: () => void;
  onReturnToHome: () => void;
}

const PlaceholderContactCompletedView: React.FC<PlaceholderContactCompletedViewProps> = ({
  tone = 'default',
  onViewContact,
  onReturnToActions,
  onReturnToHome,
}) => (
  <StyledSection tone={tone} noSidePaddingFrom="xs">
    <Box sx={{ margin: '0 auto', padding: 4 }}>
      <StyledCard tone="tone1">
        <StyledCardContent sx={{ py: 4, textAlign: 'center' }}>
          <StyledHeading headerVariant="heading2" sx={{ mb: 2, color: 'success.main' }}>
            ✓ Complete
          </StyledHeading>
          <StyledTypography sx={{ mb: 4 }}>
            The placeholder contact has been successfully processed.
          </StyledTypography>
          <Box sx={{ display: 'flex', gap: 2, justifyContent: 'center' }}>
            <StyledButton variant="contained" onClick={onViewContact}>
              View Contact
            </StyledButton>
            <StyledButton variant="contained" onClick={onReturnToActions}>
              Return to Actions
            </StyledButton>
            <StyledButton variant="outlined" onClick={onReturnToHome}>
              Return to Home
            </StyledButton>
          </Box>
        </StyledCardContent>
      </StyledCard>
    </Box>
  </StyledSection>
);

export default PlaceholderContactCompletedView;
